import Vue from 'vue';
import Vuex from 'vuex';
import { array, classMap, autoLoad } from '@/utils/helper';

/* Modules */
import auth from './modules/auth';
import bill from './modules/bill';
import currency from './modules/currency';
import article from './modules/article';
import shift from './modules/shift';
import staff from './modules/staff';
import customer from './modules/customer';
import commission from './modules/commission';
import toggle from './modules/toggle';
import inputPad from './modules/inputPad';
import promotion from './modules/promotion';
import printer from '@/store/modules/printer';
import expenseCategory from './modules/expenseCategory';
import setting from './modules/setting';
import stock from './modules/stock';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    auth,
    bill,
    currency,
    article,
    shift,
    staff,
    customer,
    commission,
    toggle,
    inputPad,
    promotion,
    printer,
    expenseCategory,
    setting,
    stock,
  },
  getters: {
    getMap: state => (mapName, noAutoLoad = false) => {
  if (mapName.toLowerCase() === 'stocks') {
      console.trace('getMap called with "stocks"');
      console.log('STORE INDEX getMap');
      console.log('MAP NAME', mapName);
      console.log(modules);
  }
      const modules = [];
      for (const moduleName in state) {
        for (const moduleMapName in state[moduleName]) {
          if (moduleMapName.toLowerCase() == mapName.toLowerCase()) {
            modules.push(moduleName);
          }
        }
      }

      if (modules.length == 0) {
        console.warn(`CAN NOT FIND MODULE THAT HAVE MAP <${mapName}>`);
      }
      if (modules.length > 1) {
        console.warn(`MORE THAN ONE MODULE CONTAIN SAME MAP <${mapName}>, NEED TO REMOVE`, modules);
      }

      const module = state[modules[0]];
      const map = module[mapName];
      if (noAutoLoad) return map;
      if (Object.keys(map).length == 0) {
        autoLoad(mapName, module);
      }
      return map;
    },
    getArray: (state, getters) => (
      mapName,
      directly = false,
      destroyClone = true,
    ) => {
      const list = array(getters.getMap(mapName, directly));
      return list.filter((object) => {
        const isNotDeleted = !object.deletedAt || object.deletedAt == null;
        const isClone = !!object.cloneId;
        return isNotDeleted && (!destroyClone || !isClone);
      });
    },
    getObject: (state, getters) => (value, mapName, property = 'id') => array(getters.getMap(mapName)).find(object => object[property] == value),
    getMapFromObjectClass: (state, getters) => (objectClass) => {
      if (!classMap[objectClass]) {
        console.warn('PLEASE DECLARE CLASSMAP FOR <' + objectClass + '>', classMap);
        return null;
      }
      return getters.getMap(classMap[objectClass]);
    },
    getObjectFromApi: (state, getters) => (apiObject) => {
      const map = getters.getMapFromObjectClass(apiObject.class);
      if (!map) return null;
      if (apiObject.class === 'CloneBillItem') {
        let data = null;
        Object.values(map).forEach((bill) => {
          const find = bill.billItems.find(({ id }) => id === apiObject.id);
          if (find) {
            data = bill;
          }
        });
        return data;
      }
      return map[apiObject.id];
    },
    getCloneList: (state, getters) => map => getters.getArray(map, false, false).filter(object => object.cloneId),
    getClone: (state, getters) => (object, map, list = null) => {
      if (!list) {
        list = getters.getCloneList(map);
      }
      return list.find(o => o.cloneId == object.masterId);
    },
  },
  actions: {
    saveObject({ getters }, object) {
      if (!classMap[object.class]) {
        console.warn('PLEASE DECLARE CLASSMAP FOR <' + object.class + '>', classMap);
      } else {
        Vue.set(getters.getMap(classMap[object.class]), object.id, object);
      }
    },
    deleteObject({ getters }, object) {
      const map = getters.getMapFromObjectClass(object.class);
      if (map) {
        Vue.delete(map, object.id);
      }
    },
    updateObject({ getters }, object) {
      const map = getters.getMapFromObjectClass(object.class);
      if (map) {
        Vue.delete(map, object.id);
        Vue.set(map, object.id, object);
      }
    },
  },
});
